import { render, staticRenderFns } from "./Suivi.vue?vue&type=template&id=440bcbdc&"
import script from "./Suivi.vue?vue&type=script&lang=js&"
export * from "./Suivi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports